import { all } from 'redux-saga/effects'

import { submitSaga } from './submit/saga'

export function* recommendationsSaga() {
  yield all([submitSaga()])
}
